<template>
    <div>
        <div>
            <div class="filter-container">
                <div class="left-content">
                    <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                        <template #button-content>
                            <span class="lc"><i class="icon icon-filter"></i> {{ setText('filter') }}</span><span class="rc"><i
                            class="icon icon-keyboard"></i></span>
                        </template>
                        <div>
                            <div class="top-content">
                                <span>{{ setText('filter_params') }}</span>
                                <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                            </div>
                            <!--------------- Фмнансовый год ------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('fin_year')">
                                    <multiselect v-show="year"
                                                 ref="bcPlanYear"
                                                 v-model="planPeriod"
                                                 track-by="name"
                                                 label="name"
                                                 :placeholder="setText('year_select')"
                                                 :options="year"
                                                 :searchable="false"
                                                 :allow-empty="false"
                                                 :show-labels="false">
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!---------------------data------------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('date')">
                                    <date-picker
                                        :placeholder="setText('date_select')"
                                        v-model="date"
                                        format = "YYYY-DD-MM"
                                        type="date"
                                        style="max-width: 1200px"
                                        @input="loadData"
                                        ref="filterDate"
                                    />
                                </b-form-group>
                            </div>
                            <!---------------------Регион---------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('obl')">
                                    <multiselect
                                        v-model="currRegion"
                                        label="localText"
                                        :placeholder="setText('region_select')"
                                        :options="regionBase"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        ref="filterReg"
                                    />
                                </b-form-group>
                            </div>
                            <!---------------------Статус справки---------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('status')">
                                    <multiselect
                                        v-model="selectedStatuses"
                                        label="name"
                                        track-by="code"
                                        :custom-label="statusLabel"
                                        :placeholder="setText('status_select')"
                                        :options="statusBase"
                                        :multiple="true"
                                        :searchable="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        :show-labels="false"
                                        ref="filterStatus">
                                        <template slot="beforeList"><b-badge pill variant="primary" @click="selectAllStatusesChanged()">{{ setText('all') }}</b-badge></template>
                                        <template slot="selection" slot-scope="{ values, isOpen }">
                                            <template v-if="!isOpen">
                                                <template v-if="values.length > 1">
                                                    <span class="multiselect__single" id="multiselect__single_status">
                                                        -- {{ displayStatusText(values.length) }} --
                                                    </span>
                                                </template>
                                                <template v-else-if="values.length === 1">
                                                    <span>{{ statusLabel(values[0]) }}</span>
                                                </template>
                                            </template>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-form-group :label="setText('8_cat')">
                                    <div class="modal__toggle">
                                        <b-form-checkbox v-model="cat8" switch/>
                                    </div>
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-button variant="primary" @click="loadData()">{{ setText('apply') }}</b-button>
                            </div>
                        </div>
                    </b-dropdown>
                </div>
            </div>
        </div>

        <div class="actions-tab in-tab">
            <!---------------Форма для скачивания отчета--------------->
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                                    <span class="left">
                                        <i class="icon icon-download"></i> {{ setText('download') }}
                                    </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="download">{{ setText('balance_budg') }}</b-dropdown-item>
            </b-dropdown>
        </div>
        <!--  хлебные крошки   -->
        <div class="filter-breadcrumb">
            <span class="item-breadcrumb" v-if="date" @click="openFilterByRef('filterDate')"> {{ date | formatDate }} </span>
            <span class="item-breadcrumb" v-if="currRegion" @click="openFilterByRef('filterReg')"> {{ currRegion.localText}} </span>
            <span class="item-breadcrumb" v-if="selectedStatuses.length" @click="openFilterByRef('filterStatus')"> {{ setText('status') }} - {{ statusesBreadcrumbText }} </span>
        </div>
        <div class="top-table-line"></div>
        <balance-tab :table-data="budgetForm" :accessLevel="accessLevels"/>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import VueElementLoading from "vue-element-loading";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import moment from 'moment';
import balanceTab from "./tableDir/balanceTab";
import {Ax} from "@/utils";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
// расходы
export default {
    name: "balanceTable",
    components: { DatePicker, 'loading': VueElementLoading, balanceTab },
    mixins: [ AlterationI18nMixin ],
    props: [ "accessLevels", "userId", "regionBase", "isLoadToJournalEnabled" ],
    data() {
        return {
            date: new Date(),
            loading: false,
            currRegion: null,
            budgetForm: [],
            planPeriod: null,
            year: [],
            // «Используемые остатки бюджетных средств»: по умолчанию включён (EAK-2027)
            cat8: true,
            statusBase: [],
            selectedStatuses: []
        }
    },
    computed: {
        isAllStatusesSelected() {
            return this.selectedStatuses.length === this.statusBase.length;
        },
        statusesBreadcrumbText() {
            return this.selectedStatuses.map((item) => item.code).sort((a, b) => a - b).join(', ');
        }
    },
    created() {
        // статусы нужны до первого запроса баланса: loadData дожидается этого промиса
        this.statusesLoading = this.loadStatuses();
    },
    async mounted() {
        this.loading = true;
        this.years(this, this.year);
        this.currRegion = this.regionBase[0];
        if (this.currRegion !== undefined) {
            await this.loadData();
        }
        this.loading = false;
    },
    watch: {
        "regionBase": function () {
            this.currRegion = this.regionBase[0];
            setTimeout(() => this.loadData(), 100);
        }
    },
    methods: {
        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            this.$emit('openFilterByRef', refName);
            let refItem;
            switch (refName) {
                case 'filterDate':
                    refItem = this.$refs.filterDate;
                    break;
                case 'filterReg':
                    refItem = this.$refs.filterReg;
                    break;
                case 'filterStatus':
                    refItem = this.$refs.filterStatus;
                    break;
                default: break;
            }
            setTimeout(() => refItem.$el.focus(), 100);
        },
        // справочник статусов справок для баланса (выбор по умолчанию - 39, см. EAK-1680)
        async loadStatuses() {
            try {
                const response = await fetch('/api-py/alteration-balance-statuses');
                if (!response.ok) {
                    throw new Error(`${response.status} - ${response.statusText}`);
                }
                const statuses = await response.json();
                this.nameLocale(statuses);
                this.statusBase = statuses;
                const defaultStatus = this.statusBase.find((item) => Number(item.code) === 39);
                this.selectedStatuses = defaultStatus ? [defaultStatus] : [];
            } catch (error) {
                this.statusBase = [];
                this.selectedStatuses = [];
                this.makeToast('danger', this.setText('errors.status'), error.toString());
            }
        },
        statusLabel(item) {
            return `${item.code} - ${item.name}`;
        },
        selectAllStatusesChanged() {
            if (this.isAllStatusesSelected) {
                this.selectedStatuses = [];
            } else {
                this.selectedStatuses = this.statusBase.slice();
            }
        },
        displayStatusText(count) {
            if (count === this.statusBase.length) {
                return this.setText('all');
            }
            // форма слова по числу (ru: 1 статус, 2 статуса, 5 статусов); нет формы в локали - берём other
            const form = new Intl.PluralRules(this.$i18n.locale).select(count);
            const key = this.$te(`modules.budget_execution_alteration.statuses_sel.${form}`) ? form : 'other';
            return count + this.setText(`statuses_sel.${key}`);
        },
        // собирает общие параметры запроса баланса (см. EAK-1680 - статусы справок выбираются пользователем)
        balanceParams() {
            const params = {
                year: this.planPeriod.year,
                date: moment(this.date).format('YYYY-MM-DD'),
                region: this.currRegion.code,
                cat8: this.cat8
            };
            // если справочник статусов не загрузился, statuses не передаём - sit-py учтёт только статус 39
            if (this.statusBase.length) {
                params.statuses = this.selectedStatuses.map((item) => item.code);
            }
            return params;
        },
        // справочник статусов загружен, но ни один статус не выбран
        isStatusesEmpty() {
            return this.statusBase.length > 0 && this.selectedStatuses.length === 0;
        },
        async loadData() {
            let response = [];
            await this.statusesLoading;
            if (this.isStatusesEmpty()) {
                this.makeToast('warning', this.setText('status'), this.setText('errors.balance_statuses'));
                return;
            }
            try {
                this.budgetForm = [];
                const params = Object.assign(this.balanceParams(), { uid: this.$store.getters.user_uuid });
                response = await fetch(`/api-py/alteration-balance/` + encodeURI(JSON.stringify(params)));
                this.budgetForm = await response.json();
            } catch (error) {
                response = [];
                this.loading = false;
                this.makeToast("danger", this.setText('errors.balance'), 'Не все параметры заданы');
            }
        },
        years(vue, arrYears) {
            const curYear = new Date().getFullYear();
            for (let i = curYear + 1; i >= 2023; i--) {
                const item = {year: i, name: `${i}`};
                arrYears.push(item);
                if (item.year === curYear) {
                    vue.planPeriod = item;
                }
            }
        },
        async download(val) {
            const that = this;
            if (this.isStatusesEmpty()) {
                this.makeToast('warning', this.setText('status'), this.setText('errors.balance_statuses'));
                return;
            }
            // В колонку журнала «Статус справки» пишется одно число (в sit-py приводится к int):
            // 39, если он выбран, иначе наименьший из выбранных кодов. Полный список уходит в statuses.
            const statusCodes = this.selectedStatuses.map((item) => Number(item.code)).sort((a, b) => a - b);
            const journalAgreementStatus = String(statusCodes.length && !statusCodes.includes(39) ? statusCodes[0] : 39);

            if (this.isLoadToJournalEnabled) {
                // Выгрузка в журнал
                const filename = `${this.setText('balance_budg')}_${that.currRegion.code}_${moment(that.date).format('DD.MM.YYYY')}.xls`
                const params = Object.assign(this.balanceParams(), {
                    name: 'Балансировка бюджета',
                    user_id: this.$store.getters.user_uuid,
                    agreement_status: journalAgreementStatus,
                    report_key: 'BALANCE',
                    source_tab: 'balance',
                    filename: filename
                })

                const response = await fetch('/api-py/alteration/journal', {
                    method: 'POST',
                    body: JSON.stringify(params)
                })
                if (!response.ok) {
                    this.makeToast('danger', 'Ошибка запроса downloadRep()', response.statusText || String(response.status));
                    return
                }
                const journalId = await response.text()
                fetch(`/api-py/alteration/journal/${journalId}`, {
                    method: 'PUT'
                })
                this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')
                this.$emit('reload-journal')
            } else {
                // Прямая выгрузка
                const params = Object.assign(this.balanceParams(), { user_id: this.$store.getters.user_uuid });
                Ax(
                    {
                        url: '/api-py/balance-download/' +  encodeURI(JSON.stringify(params)), //  Тело файла
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        let name = ''
                        name += `_${that.currRegion.code}_${moment(that.date).format('DD.MM.YYYY')}`
                        link.setAttribute('download', this.setText('balance_budg') + `${name}.xls`);// or any other extension
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        that.error = error;
                    }
                );
            }
        }
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
}
</script>


<style lang="scss" scoped>
.content {
    display: flex;
    gap: 20px;
    background-color: #eef1f8;
    justify-content: space-between;
}

.content {
    height: 100%;
    .title {
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        padding-left: 20px;
        margin-bottom: 26px;
    }
    .constructor,
    .forms {
        flex: 1;
    }

    .body {
        background-color: #f7f9fc;
    }

    .item {
        display: flex;
        align-items: center;
        height: 48px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0px 10px 0px 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .multiselect {
        max-width: 400px;
    }

    .footer {
        display: flex;
        height: 48px;
        align-items: center;
        justify-content: end;
        border: 1px solid #d3dbe3;
        border-top: 0;
        padding-right: 40.5%;
    }

    .vertical-line {
        width: 1px;
        background-color: #d3dbe3;
        margin-top: 40px;
    }
}

.button {
    border: none;
    border-radius: 10px;
}

.button-close {
    color: red;
}

.date-picker-container {
    display: flex;
    gap: 79px;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #6087a0;

    input[type="number"] {
        border: 1px solid #bcd2e0;
        border-radius: 5px;
        padding-right: 5px;
        max-width: 80px;
        height: 28px;
        text-indent: 7px;
        text-align: left;
    }
}

</style>